import { UtilApp } from "./UtilApp";

export class SoundUtil {

  static playInvitedToCall() {
    this.play("/assets/sound/n_invited2.wav");
  }

  static playJoined() {
    this.play("/assets/sound/n_joined.wav");
  }

  static playLeft() {
    this.play("/assets/sound/n_left.wav");
  }

  static playNewMessage() {
    this.play("/assets/sound/n_new_message2.wav");
  }
  
  static playNewReaction() {
    this.play("/assets/sound/n_new_reaction.wav")
  }

  static async play(path: string) {
    let audio = new Audio(path);
    try {
      await audio.play();
    } catch (error) {
      console.info(error);
    }
  }
}

if (UtilApp.isSafariBrowser()) {
  const unlockAudio = () => {
    console.log("Unlocking audio play for Safari.");
    SoundUtil.play("/assets/sound/silent.wav");
    document.body.removeEventListener('click', unlockAudio)
    document.body.removeEventListener('touchstart', unlockAudio)
  }

  document.body.addEventListener('click', unlockAudio);
  document.body.addEventListener('touchstart', unlockAudio);
}